import { ConsignmentDetails, PointOfSaleType } from 'types';
import { ConfirmInvoice, WaitingInvoice } from './components';

interface Props {
  consignment: ConsignmentDetails;
  isPickupInStore: boolean;
  setShowRefuse: (value: boolean) => void;
}

export function StepInvoice({
  consignment,
  isPickupInStore,
  setShowRefuse,
}: Props) {
  const { pointOfSale } = consignment;

  if (pointOfSale.type === PointOfSaleType.Manual) {
    return (
      <ConfirmInvoice
        consignment={consignment}
        isPickupInStore={isPickupInStore}
        setShowRefuse={setShowRefuse}
      />
    );
  }

  return (
    <WaitingInvoice
      consignment={consignment}
      isPickupInStore={isPickupInStore}
    />
  );
}
